'use client';

import { ReactNode } from 'react';
import { useInView } from 'react-intersection-observer';

interface ScrollAnimationProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  threshold?: number;
}

/**
 * Performance-optimized scroll animation wrapper.
 * Uses react-intersection-observer with triggerOnce for efficiency.
 * On mobile, animations are instant to prevent jank.
 */
export function ScrollAnimation({
  children,
  className = '',
  delay = 0,
  threshold = 0.1,
}: ScrollAnimationProps) {
  const { ref, inView } = useInView({
    threshold,
    triggerOnce: true, // Critical: only trigger once for performance
  });

  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(20px)',
        transition: `opacity 0.6s ease-out ${delay}ms, transform 0.6s ease-out ${delay}ms`,
      }}
    >
      {children}
    </div>
  );
}
